<script setup>
import { useLayout2WeeklyAssignedContentsStore } from "@/modules/Layout2/stores/useLayout2WeeklyAssignedContents.store";
import HomeMainContentCard from "./partials/HomeMainContentCard.vue";
import { storeToRefs } from "pinia";

const layout2WeeklyAssignedContentStore =
  useLayout2WeeklyAssignedContentsStore();
const { loadingWeeklyAssignedContentsCurrentWeek, currentWeekAssigned } =
  storeToRefs(layout2WeeklyAssignedContentStore);
</script>
<template>
  <div class="w-full">
    <ul
      role="list"
      class="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-3"
      v-if="
        !loadingWeeklyAssignedContentsCurrentWeek && currentWeekAssigned.length
      "
    >
      <li
        class="col-span-1"
        v-for="assignment in currentWeekAssigned"
        :key="assignment.id"
      >
        <HomeMainContentCard :content="assignment" />
      </li>
    </ul>

    <div
      class="w-full flex justify-center items-center lg:min-h-72 h-72 border border-brand-light/20 rounded-md"
      v-if="
        !loadingWeeklyAssignedContentsCurrentWeek && !currentWeekAssigned.length
      "
    >
      <h1 class="font-semibold text-sm text-brand/40">
        No Assignments This Week
      </h1>
    </div>
    <ul
      role="list"
      v-if="loadingWeeklyAssignedContentsCurrentWeek"
      class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3"
    >
      <li
        class="col-span-1 h-72 bg-brand/10 flex flex-col overflow-hidden rounded-md"
        v-for="n in 9"
        :key="n"
      >
        <div class="w-full flex-1 bg-brand/20 animate-pulse" />
        <div class="w-full h-20"></div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped></style>
